// ================= Featured Collection Tabs =================

class FeaturedCollectionTabs {
  constructor(section) {
    this.section = section;
    this.tabs = [...section.querySelectorAll(".featured-collections-tabs__tab")];
    this.panels = [...section.querySelectorAll(".featured-collections-tabs__panel")];

    if (!this.tabs.length || !this.panels.length) return;

    this.activeIndex = this.tabs.findIndex((tab) =>
      tab.classList.contains("is-active")
    );

    if (this.activeIndex < 0) this.activeIndex = 0;

    this.section.addEventListener("click", this.onClick.bind(this));
    this.section.addEventListener("keydown", this.onKeydown.bind(this));
  }

  onClick(event) {
    const tab = event.target.closest(".featured-collections-tabs__tab");
    if (!tab) return;

    const index = this.tabs.indexOf(tab);
    if (index !== -1) {
      this.activateTab(index);
    }
  }

  onKeydown(event) {
    const currentTab = event.target.closest(".featured-collections-tabs__tab");
    if (!currentTab) return;

    const index = this.tabs.indexOf(currentTab);

    let newIndex;

    switch (event.key) {
      case "ArrowRight":
        newIndex = (index + 1) % this.tabs.length;
        break;

      case "ArrowLeft":
        newIndex = (index - 1 + this.tabs.length) % this.tabs.length;
        break;

      case "Home":
        newIndex = 0;
        break;

      case "End":
        newIndex = this.tabs.length - 1;
        break;

      default:
        return;
    }

    event.preventDefault();

    this.activateTab(newIndex);
    this.tabs[newIndex].focus();
  }

  activateTab(index) {
    if (index === this.activeIndex) return;

    // Old active
    const oldTab = this.tabs[this.activeIndex];
    const oldPanel = this.panels[this.activeIndex];

    oldTab.classList.remove("is-active");
    oldTab.setAttribute("aria-selected", "false");
    oldTab.tabIndex = -1;

    oldPanel.classList.remove("is-active");
    oldPanel.hidden = true;

    // New active
    const newTab = this.tabs[index];
    const newPanel = this.panels[index];

    newTab.classList.add("is-active");
    newTab.setAttribute("aria-selected", "true");
    newTab.tabIndex = 0;

    newPanel.classList.add("is-active");
    newPanel.hidden = false;

    this.activeIndex = index;
  }
}

// ================= Reusable Splide =================

function mountSplide(selector, options, initializedClass = "") {
  document.querySelectorAll(selector).forEach((slider) => {
    if (
      initializedClass &&
      slider.classList.contains(initializedClass)
    ) {
      return;
    }

    if (slider.querySelectorAll(".splide__slide").length <= 1) return;

    new Splide(slider, options).mount();

    if (initializedClass) {
      slider.classList.add(initializedClass);
    }
  });
}

// ================= Featured Product Slider =================

function initFeaturedProductSliders() {
  mountSplide('[class*="featured-product-splide-"]', {
    type: "loop",
    perPage: 1,
    perMove: 1,
    arrows: false,
    pagination: true,
    autoplay: false,
    interval: 2000,
    pauseOnHover: true,
    pauseOnFocus: false,
    resetProgress: false,
    gap: "16px",
    speed: 600,
  });
}

// ================= Related Products Slider =================

function initRelatedProductSliders() {
  mountSplide(
    ".related-products-slider",
    {
      type: "slide",
      perPage: 4,
      perMove: 1,
      gap: "4px",
      arrows: false,
      pagination: false,
      drag: true,
      rewind: false,

      breakpoints: {
        990: {
          perPage: 2,
        },
        749: {
          perPage: 2,
        },
      },
    },
    "is-initialized"
  );
}

// ================= Featured Tabs =================

function initFeaturedTabs(root = document) {
  root
    .querySelectorAll(".featured-collections-tabs")
    .forEach((section) => {
      if (!section.featuredTabsInstance) {
        section.featuredTabsInstance = new FeaturedCollectionTabs(section);
      }
    });
}

// ================= Featured Collection Tabs Product Slider =================

function initFeaturedTabsProductSliders(root = document) {
  root.querySelectorAll(".featured-tabs-product-splide").forEach((slider) => {
    if (slider.classList.contains("is-initialized")) return;

    const slides = slider.querySelectorAll(".splide__slide");

    if (slides.length <= 2) return;

    new Splide(slider, {
      type: "slide",
      perPage: 5,
      perMove: 1,
      gap: "4px",
      arrows: true,
      pagination: false,
      drag: true,
      rewind: false,

      breakpoints: {
        749: {
          perPage: 2,
          gap: "4px",
        },
      },
    }).mount();

    slider.classList.add("is-initialized");
  });
}

// blog slide in mobile =============
function initMobileBlogSlider(root = document) {
  if (!window.matchMedia("(max-width: 989px)").matches) return;
  root.querySelectorAll(".mobile_only-blog").forEach((slider) => {
    if (slider.classList.contains("is-initialized")) return;

    const slides = slider.querySelectorAll(".splide__slide");

    if (slides.length <= 1) return;

    new Splide(slider, {
      type: "slide",
      perPage: 1,
      perMove: 1,
      gap: "4px",
      arrows: false,
      pagination: false,
      drag: true,
      rewind: false,
      speed: 500,
    }).mount();

    slider.classList.add("is-initialized");
  });
}

// ================= Init =================

function init(root = document) {
  initFeaturedTabs(root);
  initFeaturedTabsProductSliders(root);
  initFeaturedProductSliders();
  initRelatedProductSliders();
  initMobileBlogSlider(root);
}

document.addEventListener("DOMContentLoaded", () => {
  init();

  const recommendations = document.querySelector("product-recommendations");

  if (recommendations) {
    const observer = new MutationObserver((mutations) => {
      if (mutations.some((m) => m.addedNodes.length)) {
        initRelatedProductSliders();
      }
    });

    observer.observe(recommendations, {
      childList: true,
      subtree: true,
    });
  }
});

document.addEventListener("shopify:section:load", (event) => {
  init(event.target);
});



// --------------------------------------------------------------
